import { useEffect, useState } from "react";
import { Trophy, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { fcfa } from "../../lib/format";

const MEDALS = ["🥇", "🥈", "🥉"];

export function TopVendeurs() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/top-vendeurs").then(({ data }) => setRows(data)).catch(() => setRows(false)); }, []);

  if (rows === null) return <div className="bg-white border border-brand-line rounded-2xl p-6 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;
  if (rows === false) return null;

  const monthLabel = new Date().toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

  return (
    <div data-testid="top-vendeurs" className="bg-white border border-brand-line rounded-2xl p-5 sm:p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-9 h-9 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><Trophy className="w-5 h-5" /></span>
        <div>
          <h2 className="font-heading font-bold text-brand-ink">Meilleurs vendeurs</h2>
          <p className="text-xs text-brand-muted capitalize">{monthLabel}</p>
        </div>
      </div>
      {rows.length === 0 || rows.every((r) => r.sales === 0) ? (
        <p className="text-sm text-brand-muted">Aucune vente ce mois-ci pour l'instant.</p>
      ) : (
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={r.seller_id} data-testid={`top-vendeur-${i}`} className={`flex items-center justify-between rounded-xl px-4 py-3 ${i === 0 ? "bg-amber-50 border border-amber-200" : "border border-brand-line"}`}>
              <div className="flex items-center gap-3">
                <span className="text-lg w-6 text-center">{MEDALS[i] || `${i + 1}.`}</span>
                <div>
                  <p className="font-semibold text-brand-ink text-sm">{r.name}</p>
                  <p className="text-xs text-brand-muted">{r.orders} vente(s) · commission {fcfa(r.commission)}</p>
                </div>
              </div>
              <p className="font-heading font-black text-brand">{fcfa(r.sales)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
